const selectors = {
  btn: '.js-go-top-btn',
};

const handleGoTopBtn = () => {
  const btn = document.querySelector(selectors.btn);

  if (btn === null) return;

  btn.addEventListener('click', () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  });
};
export default handleGoTopBtn;
